/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface InvitationFormDto {
  email: string;
  language: InvitationFormDto.LanguageEnum;
  roles: Array<InvitationFormDto.RolesEnum>;
  organization: number;
}
export namespace InvitationFormDto {
  export type LanguageEnum = 'fr' | 'nl';
  export const LanguageEnum = {
    Fr: 'fr' as LanguageEnum,
    Nl: 'nl' as LanguageEnum,
  };
  export type RolesEnum = 'SUPER_ADMIN' | 'ORGANIZATION_ADMIN' | 'USER';
  export const RolesEnum = {
    SUPERADMIN: 'SUPER_ADMIN' as RolesEnum,
    ORGANIZATIONADMIN: 'ORGANIZATION_ADMIN' as RolesEnum,
    USER: 'USER' as RolesEnum,
  };
}
